import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useCurrencySymbol } from '../../../../utils/currencyUtils';
import { useDispatch, useSelector } from 'react-redux';
import { goBack, goNext, goToStep, setCreatedProject, setOperationProjectStatus } from '../../../../store/slices/WizardSlice/wizardStepSlice';
import { setCurrentPageTitle } from '../../../../store/slices/pageSlice';
import useSubscriptionLevel from '../../../../utils/SubscriptionLevel';
import { fetchLeads, updateLead } from '../../../../store/slices/leadsSlice';
import { fetchSalesTaxes } from '../../../../store/slices/salesTaxesSlice';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { fetchDescriptionTasks } from '../../../../store/slices/DescriptionTask';
import useMatchedProject from '../useMatchedProject';
import { fetchAllProjects } from '../../../../store/slices/projectsSlice';
import { fetchEmployees } from '../../../../store/slices/employeeSlice';
import { fetchHardwareDescriptions } from '../../../../store/slices/hardwareDescriptionSlice';
import { fetchWorkEntries } from '../../../../store/slices/workentriesSlice';
import { fetchQuotations } from '../../../../store/slices/hourlyRates';
import AllServiceTable from '../../../Operations/SalesOperations/SalesFinance/TableSalesFinance/AllServiceTable';
import HardwareTypeServiceTable from '../../../Operations/SalesOperations/SalesFinance/TableSalesFinance/HardwareTypeServiceTable';
import SalesFinanceEfforts from '../../../Operations/SalesOperations/SalesFinance/TableSalesFinance/SalesFinanceEfforts';
import SoftwareTypeServiceTable from '../../../Operations/SalesOperations/SalesFinance/TableSalesFinance/SoftwareTypeServiceTable';
import useWizardCommaConvert from '../../../../utils/useWizardCommaConvert';
import QuotationWizard from './QuotationWizard';
import { fetchSalesHourlyRates } from '../../../../store/slices/salesHourlyRateSlice';
import { fetchGroups } from '../../../../store/slices/groupSlice';

const PandLWizardAdvancedPlan = () => {
    const currency = useCurrencySymbol();
    const dispatch = useDispatch();
    const USAComma = useWizardCommaConvert();
    const subscriptionPackage = useSubscriptionLevel();
    const createdProject = useSelector((state) => state.wizardstep.createdProject);
    const operationProjectStatus = useSelector((state) => state.wizardstep.operationProjectStatus);
    const step = useSelector((state) => state.wizardstep.step);
    const { taxes } = useSelector((state) => state.salesTaxes);
    const { tasks } = useSelector((state) => state.descriptionTasks);
    const { projects } = useSelector((state) => state.projects);
    const { employees } = useSelector((state) => state.employees);
    const { entries } = useSelector((state) => state.workentries);
    const { items } = useSelector((state) => state.hardwareDescription);
    const { quotations } = useSelector((state) => state.hourlyRateQuotation);
    const { data } = useSelector(
        (state) => state.salesHourlyRate
    );
    const selectedProjectName = createdProject[0]?.ProjectName
    const { group: groups } = useSelector((state) => state.group);
    const { SalesStatus } = useMatchedProject(selectedProjectName);

    const [clickedProject, setClickedProject] = useState(null)

    useEffect(() => {
        dispatch(setCurrentPageTitle("Profit and Loss(P&L) Tracker"));
        dispatch(fetchSalesTaxes());
        dispatch(fetchDescriptionTasks());
        dispatch(fetchAllProjects());
        dispatch(fetchEmployees());
        dispatch(fetchWorkEntries());
        dispatch(fetchHardwareDescriptions());
        dispatch(fetchQuotations());
        dispatch(fetchSalesHourlyRates());
        dispatch(fetchGroups());
        dispatch(fetchLeads());
    }, [dispatch]);

    const groupNameById = React.useMemo(() => {
        const map = new Map();
        (groups || []).forEach((g) => {
            const id = g?._id || g?.id;
            const name = g?.newGroupName || g?.groupname || g?.groupName || g?.name || "";
            if (id && name) map.set(String(id), name);
        });
        return map;
    }, [groups]);

    const getDisplayGroupName = React.useCallback((item) => {
        const groupId = item?.groupid?._id || item?.groupid;
        if (groupId && groupNameById.has(String(groupId))) {
            return groupNameById.get(String(groupId));
        }
        return item?.AssignedGroup || "";
    }, [groupNameById]);

    const [generatedQuotation, setGeneratedQuotation] = useState([]);
    console.log("generatedQuotation quotations", quotations)
    console.log("generatedQuotation createdProject", createdProject)

    useEffect(() => {
        const leadid = createdProject[0]?.id;
        console.log("generatedQuotation leadid", leadid)

        if (quotations?.length > 0 && leadid) {
            const filteredQuotations = quotations.filter((q) => q.leadid === leadid);
            setGeneratedQuotation(filteredQuotations);
        }
    }, [quotations, createdProject]);
    console.log("generatedQuotation wizard", generatedQuotation)



    const [showQuoteModal, setShowQuoteModal] = useState(false);
    const [GandATax, setGandATax] = useState(0);
    const [taxValue, setTaxValue] = useState(0);

    useEffect(() => {
        const norm = (name) => (name || "").toString().trim().toLowerCase();
        const toPct = (val) => (typeof val === "number" ? val : Number(val)) || 0;
        // Defaults from G&A/Tax settings when tax table is empty or has no matching rows
        let gaPct = 15;
        let taxPct = 27;
        if (Array.isArray(taxes) && taxes.length > 0) {
            taxes.forEach((data) => {
                if (!data) return;
                const name = norm(data.taxName ?? data.tax_name);
                const pct = toPct(data.taxPercentage ?? data.tax_percentage);
                if (name === norm("G&A Expenses")) gaPct = pct;
                else if (name === norm("Tax")) taxPct = pct;
            });
        }
        setGandATax(gaPct);
        setTaxValue(taxPct);
    }, [taxes]);

    console.log("subscriptionPackage", subscriptionPackage)
    const [quotedExpensesValue] = useState({})
    // const [quotedExpensesValue, setQuotedExpensesValue] = useState({})
    const [quotedValueState, setQuotedValueState] = useState({})

    // const handleQuotedExpenses = (id, value) => {
    //     setQuotedExpensesValue((prev) => ({
    //         ...prev,
    //         [id]: value
    //     }));
    // };

    const handleQuotedValue = (id, value) => {
        setQuotedValueState((prev) => ({
            ...prev,
            [id]: value
        }));
    };

    // const SubmitQuotedExpenses = async (proj, value) => {
    //     try {
    //         await dispatch(updateQuotedExpense({
    //             id: proj.id,       // FIXED HERE
    //             quotedExpense: Number(value)
    //         }));
    //         dispatch(fetchLeads());  // this repopulates createdProject correctly
    //     } catch (error) {
    //         console.error("Error:", error);
    //     }
    // };

    const SubmitQuotedValueState = async (proj, value) => {
        const updatedLeadData = {
            ProjectName: proj?.ProjectName,
            QuotedValue: Number(value),
            quotationId: proj?.quotationId,
        }
        try {
            await dispatch(updateLead({
                id: proj.id,       // FIXED HERE
                updatedData: updatedLeadData
            }));
            dispatch(fetchLeads());  // this repopulates createdProject correctly
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const [calculatedFinanceProjects, setCalculatedFinanceProjects] = useState([]);
    const [financeDataProject, setfinanceDataProject] = useState([]);
    const [matchedProjects, setMatchedProjects] = useState([]);
    const [matchedEntries, setMatchedEntries] = useState([]);
    const [matchedHardwareEntries, setMatchedHardwareEntries] = useState([]);
    const [groupedProj, setGroupedProj] = useState({});
    const [finalMappedEntries, setFinalMappedEntries] = useState([]);
    const [matchedQuotations, setMatchedQuotations] = useState({});
    const [filteredQuotation, setFilteredQuotation] = useState(null);
    const [tableServiceTotals, setTableServiceTotals] = useState({});
    // Itemized P&L "Total Cost Per Service" total — single source for Quoted Expenses (matches Sales P&L)
    const [itemizedTotalCostPerService, setItemizedTotalCostPerService] = useState({});

    const getWizardProjectKey = useCallback((proj) => {
        if (proj?.quotationId != null && String(proj.quotationId).trim() !== "") {
            return String(proj.quotationId).trim();
        }
        return String(proj?.ProjectName ?? "").trim();
    }, []);

    const isProjQuoted = useCallback((proj) => {
        return (
            proj?.isProjectQuoted === true ||
            proj?.isProjectQuoted === 1 ||
            String(proj?.isProjectQuoted || "").toLowerCase() === "true"
        );
    }, []);

    const getQuotedExpenseForProj = useCallback(
        (proj) => {
            if (isProjQuoted(proj)) {
                return Number(proj?.quotedExpense) || 0;
            }
            const key = getWizardProjectKey(proj);
            if (itemizedTotalCostPerService[key] !== undefined) {
                return itemizedTotalCostPerService[key];
            }
            return 0;
        },
        [getWizardProjectKey, isProjQuoted, itemizedTotalCostPerService]
    );

    const handleTotalCostPerServiceTotalChange = useCallback((projectKey, totalCostPerService) => {
        if (!projectKey) return;
        const total = Math.round(Number(totalCostPerService) || 0);
        setItemizedTotalCostPerService((prev) => {
            if (prev[projectKey] === total) return prev;
            return { ...prev, [projectKey]: total };
        });
    }, []);

    const wizardLeadQuotationId = createdProject?.[0]?.quotationId;
    const wizardLeadProjectName = createdProject?.[0]?.ProjectName;

    useEffect(() => {
        setItemizedTotalCostPerService({});
    }, [wizardLeadQuotationId, wizardLeadProjectName]);

    console.log("calculatedFinanceProjects createdProject", createdProject)
    console.log("calculatedFinanceProjects", calculatedFinanceProjects)

    useEffect(() => {
        if (!createdProject) return;

        const financeObject = createdProject.map((proj) => {
            const projectId = proj?._id ?? proj?.id;
            const projectName = proj?.ProjectName;
            // const QuotedValue = proj?.QuotedValue || 0;
            const QuotedValue =
                quotedValueState[proj._id] !== undefined
                    ? Number(quotedValueState[proj._id])
                    : Number(proj?.QuotedValue) || 0;

            // If input is typed → override proj.quotedExpense
            // const quotedExpense =
            //     quotedExpensesValue[proj._id] !== undefined
            //         ? Number(quotedExpensesValue[proj._id])
            //         : proj?.quotedExpense || 0;

            const quotedExpense = getQuotedExpenseForProj(proj);

            const grossProfit = QuotedValue - quotedExpense;
            const GAExpenses = grossProfit * (GandATax / 100);
            const EBIT = grossProfit - GAExpenses;
            // Tax on EBIT (Gross Profit − G&A), not on Gross Profit
            const TaxCalculated = EBIT * (taxValue / 100);
            const netRevenueInDollar = EBIT - TaxCalculated;
            const netRevenueInPercentage = QuotedValue
                ? (netRevenueInDollar / QuotedValue) * 100
                : 0;

            return {
                projectId,
                projectName,
                QuotedValue,
                quotedExpense,
                grossProfit,
                GAExpenses,
                TaxCalculated,
                netRevenueInDollar,
                netRevenueInPercentage,
            };
        });

        setCalculatedFinanceProjects(financeObject);
    }, [createdProject, GandATax, taxValue, quotedExpensesValue, getQuotedExpenseForProj, quotedValueState]);

    const handleNext = () => {
        // Check if lead status is Won - skip Generate Quotation for Won status in ERP package
        const leadStatus = createdProject[0]?.Status?.toLowerCase()?.trim();
        const isWon = leadStatus === "won" || leadStatus === "won recurring";
        
        // If Won status and SalesStatus is "generate quotation", set to "project approved" to show P&L Tracker
        let statusToSet = SalesStatus;
        if (isWon && SalesStatus === "generate quotation") {
            statusToSet = "project approved"; // This will show P&L Tracker in step 4 instead of Generate Quotation
        }
        
        // In ERP module, when coming from P&L table (status is "project approved") and all responses are accepted,
        // SalesStatus should be "generate quotation" - transition to quotation generation
        // Also handle case where we're already on step 4 and SalesStatus is "generate quotation"
        if (subscriptionPackage === "ERP") {
            if (operationProjectStatus === "project approved" && SalesStatus === "generate quotation") {
                statusToSet = "generate quotation";
            } else if (step === 4 && SalesStatus === "generate quotation" && !isWon) {
                // If we're on step 4 and SalesStatus is "generate quotation", go to quotation generation
                statusToSet = "generate quotation";
            }
        }
        
        dispatch(setOperationProjectStatus(statusToSet))
        dispatch(setCreatedProject(createdProject));
        
        // If transitioning from P&L table to Generate Quotation, stay on step 4 (don't go to step 5)
        // This allows step 4 to show Generate Quotation wizard
        if (statusToSet === "generate quotation") {
            // Stay on current step (step 4) - explicitly set step to 4 to ensure we don't go to step 5
            dispatch(goToStep(4));
        } else {
            dispatch(goNext())
        }
    }

    useEffect(() => {
        const filteredProject = projects.filter(
            (proj) => proj.isProjecttracking === false
        );

        const qualifiedGroups = filteredProject.filter((project) => {
            // Must have at least one assigned person
            if (!project?.Assignedperson?.length) return false;

            return project.Assignedperson.some((person) =>
                (
                    person.salespersonaction === "accept" ||
                    person.salespersonaction === "project not-assigned" ||
                    person.salespersonaction === "project not-assigned"

                )
                &&
                (
                    person.salespersonstatus === "response received" ||
                    person.salespersonstatus === "project approved" ||
                    person.salespersonstatus === "project not-approved" ||
                    person.salespersonstatus === "project not-assigned"
                )
            );
        });
        setfinanceDataProject(qualifiedGroups)
    }, [projects]);

    useEffect(() => {
        // Get quotationId from createdProject (if available)
        const leadQuotationId = createdProject[0]?.quotationId;
        const hasQuotationId = leadQuotationId != null && String(leadQuotationId).trim() !== "";

        if ((selectedProjectName || leadQuotationId) && financeDataProject?.length) {
            const matches = financeDataProject.filter((proj) => {
                if (hasQuotationId) {
                    // Match by quotationId first (mandatory when available)
                    return proj.quotationId != null && String(proj.quotationId).trim() === String(leadQuotationId).trim();
                }
                // Fallback to ProjectName matching if quotationId is not available
                const nameMatches =
                    proj.ProjectName?.toLowerCase() ===
                    selectedProjectName?.toLowerCase();
                return nameMatches;
            });

            setMatchedProjects(matches); // will only contain projects with valid assigned persons
        } else {
            setMatchedProjects([]); // reset if no match
        }
    }, [selectedProjectName, financeDataProject, createdProject]);

    useEffect(() => {
        if (matchedProjects.length && entries.length) {
            const matchedIds = matchedProjects.map((proj) => proj._id);
            const filteredEntries = entries.filter((entry) =>
                matchedIds.includes(entry.projectid)
            );

            const matchedPersons = matchedProjects.flatMap((project) =>
                (project.Assignedperson || [])
                    .map((person) => ({
                        ...person,
                        projectid: project._id,
                        ProjectName: project.ProjectName, // optional
                    }))
            );

            const matchedEmployees = employees.filter((employee) =>
                matchedPersons.some(
                    (person) =>
                        person.email?.trim().toLowerCase() ===
                        employee.EmpEmail?.trim().toLowerCase()
                )
            );

            const matchedPeopleEntries = filteredEntries.filter((entry) =>
                matchedEmployees.some(
                    (employee) => employee._id?.trim() === entry.taskownerid?.trim()
                )
            );

            setMatchedEntries(matchedPeopleEntries);
        } else {
            setMatchedEntries([]);
        }
    }, [matchedProjects, entries, employees]);

    useEffect(() => {
        if (matchedProjects.length && items.length) {
            const matchedIds = matchedProjects.map((proj) => proj._id);
            const filteredEntries = items.filter((entry) =>
                matchedIds.includes(entry.projectid)
            );

            const matchedPersons = matchedProjects.flatMap((project) =>
                (project.Assignedperson || [])
                    .map((person) => ({
                        ...person,
                        projectid: project._id,
                        ProjectName: project.ProjectName, // optional
                    }))
            );

            const matchedEmployees = employees.filter((employee) =>
                matchedPersons.some(
                    (person) =>
                        person.email?.trim().toLowerCase() ===
                        employee.EmpEmail?.trim().toLowerCase()
                )
            );

            const matchedPeopleEntries = filteredEntries.filter((entry) =>
                matchedEmployees.some(
                    (employee) => employee._id?.trim() === entry.taskownerid?.trim()
                )
            );

            setMatchedHardwareEntries(matchedPeopleEntries);
        } else {
            setMatchedHardwareEntries([]);
        }
    }, [matchedProjects, items, employees]);

    useEffect(() => {
        if (matchedHardwareEntries.length) {
            setMatchedEntries(prevEntries => [...prevEntries, ...matchedHardwareEntries]);
        }
    }, [matchedHardwareEntries]);

    useEffect(() => {
        if (matchedEntries.length && employees.length) {
            const mapped = matchedEntries.map((entry) => {
                const matchedEmp = employees.find((emp) => emp._id === entry.taskownerid);

                // Check if this is a hardware entry (has hardware-specific properties)
                const isHardwareEntry = entry.hasOwnProperty('assemblepartdescription') ||
                    entry.hasOwnProperty('partno') ||
                    entry.hasOwnProperty('quantity');

                if (isHardwareEntry) {
                    // Map hardware entries
                    return {
                        createdBy: {
                            email: matchedEmp?.EmpEmail || "",
                            name: `${matchedEmp?.EmpFirstName || ""} ${matchedEmp?.EmpLastName || ""}`,
                            role: matchedEmp?.customRoles || [],
                        },
                        assemblepartdescription: entry.assemblepartdescription,
                        partno: entry.partno,
                        quantity: entry.quantity,
                        unitprice: entry.unitprice,
                        totalprice: entry.totalprice,
                        permonth: entry.permonth,
                        taskstatus: entry.taskstatus,
                        _id: entry._id,
                        taskownerid: entry.taskownerid,
                        TypeService: entry.typeservice || "Hardware", // Use the existing typeservice field
                        projectid: entry.projectid,
                    }
                } else {
                    // Map software/cloud/installation entries (your existing logic)
                    return {
                        createdBy: {
                            email: matchedEmp?.EmpEmail || "",
                            name: `${matchedEmp?.EmpFirstName || ""} ${matchedEmp?.EmpLastName || ""}`,
                            role: matchedEmp?.customRoles || [],
                        },
                        task: entry.task,
                        hoursassigned: entry.hoursassigned,
                        taskStatus: entry.taskStatus,
                        notes: entry.notes,
                        _id: entry._id,
                        taskownerid: entry.taskownerid,
                        TypeService: entry.typeservice || matchedEmp?.servicetype,
                        projectid: entry.projectid,
                    };
                }
            });

            setFinalMappedEntries(mapped);
        } else {
            setFinalMappedEntries([]);
        }
    }, [matchedEntries, employees]);

    useEffect(() => {
        if (!projects || projects.length === 0 || !employees) return;

        const grouped = {};
        projects.forEach((proj) => {
            const projectName = proj.ProjectName;
            const typeService = proj.TypeService;
            const projectId = proj._id;
            const matchedEntries = finalMappedEntries.filter(
                (entry) =>
                    entry.TypeService === typeService && entry.projectid === projectId
            );
            if (matchedEntries.length === 0) return;
            const salesperson = employees.find(
                (emp) => emp.EmpEmail === proj.SalesPersonEmail
            );
            const filteredProject = {
                TypeService: proj.TypeService,
                ResourceType: proj.ResourceType,
                ProjectName: proj.ProjectName,
                quotationId: proj?.quotationId,
                QuotedValue: proj.ServiceValue,
                ProjectMargin: proj.Salesmargin,
                isMarginupdated: proj.isMarginupdated ?? proj.isMarginUpdated ?? false,
                WorkEntries: matchedEntries,
                AssignedGroup: getDisplayGroupName(proj),
                AssignedManagerEmail: proj.AssignedManagerEmail,
                Assignedperson: proj.Assignedperson,
                ProjectID: proj._id,
                ProjectNotes: proj?.ProjectFinanceNotes,
                SalesPersonId: salesperson ? salesperson._id : null // Add salesperson _id or null if not found
            };

            if (!grouped[projectName]) {
                grouped[projectName] = {};
            }

            if (!grouped[projectName][typeService]) {
                grouped[projectName][typeService] = [];
            }

            grouped[projectName][typeService].push(filteredProject);
        });

        setGroupedProj(grouped);
    }, [projects, employees, finalMappedEntries, getDisplayGroupName]);


    useEffect(() => {
        if (!data || !groupedProj || !projects) return;
        const updatedGroupedProj = {};
        Object.entries(groupedProj).forEach(([projectName, serviceTypes]) => {
            updatedGroupedProj[projectName] = {};

            Object.entries(serviceTypes).forEach(([typeService, serviceArray]) => {
                const updatedServiceArray = serviceArray.map((entry) => {
                    // Find the corresponding project to check if it's quoted
                    const matchedProject = projects.find(
                        (proj) => proj._id === entry.ProjectID && 
                        proj.ProjectName === projectName && 
                        proj.TypeService === typeService
                    );

                    // If project is quoted, use locked hourly rates from project
                    if (matchedProject?.isProjectQuoted) {
                        const managerHourlyRate = matchedProject.managerHourlyRate || 0;
                        const operationHourlyRate = matchedProject.operationHourlyRate || 0;

                        // Create locked quotation details based on roles
                        const lockedQuotationDetails = [];
                        
                        // Find manager quotation from data to get designation
                        const managerQuotation = data.find((q) =>
                            q.designation?.toLowerCase().includes("manager") &&
                            q.designation?.toLowerCase().includes(typeService.toLowerCase()) &&
                            q.createdBy === entry.SalesPersonId
                        );
                        
                        // Find operations quotation from data to get designation
                        const operationQuotation = data.find((q) =>
                            q.designation?.toLowerCase().includes("operation") &&
                            q.designation?.toLowerCase().includes(typeService.toLowerCase()) &&
                            q.createdBy === entry.SalesPersonId
                        );

                        // Create locked manager quotation if exists
                        if (managerQuotation && managerHourlyRate > 0) {
                            lockedQuotationDetails.push({
                                ...managerQuotation,
                                hourlysalaray: managerHourlyRate,
                                overheadpercentage: 0, // Already included in managerHourlyRate
                            });
                        }

                        // Create locked operations quotation if exists
                        if (operationQuotation && operationHourlyRate > 0) {
                            lockedQuotationDetails.push({
                                ...operationQuotation,
                                hourlysalaray: operationHourlyRate,
                                overheadpercentage: 0, // Already included in operationHourlyRate
                            });
                        }

                        return {
                            ...entry,
                            quotationDetails: lockedQuotationDetails.length > 0 ? lockedQuotationDetails : [], // Use locked rates
                        };
                    } else {
                        // Project not quoted, use current rates from settings
                        const matchedQuotations = data.filter((q) =>
                            q.designation?.toLowerCase().includes(typeService.toLowerCase()) &&
                            q.createdBy === entry.SalesPersonId
                        );
                        return {
                            ...entry,
                            quotationDetails: matchedQuotations, // add new key with matched quotations
                        };
                    }
                });

                updatedGroupedProj[projectName][typeService] = updatedServiceArray;
            });
        });

        setMatchedQuotations(updatedGroupedProj);
    }, [data, groupedProj, projects]);

    useEffect(() => {
        // Get quotationId from createdProject (if available)
        const leadQuotationId = createdProject[0]?.quotationId;
        const hasQuotationId = leadQuotationId != null && String(leadQuotationId).trim() !== "";

        if ((!selectedProjectName && !hasQuotationId) || !matchedQuotations) return;
        
        // Use quotationId-based filtering if available, otherwise use ProjectName
        // Since matchedQuotations is keyed by ProjectName, we need to find the right key
        // The matchedProjects should already be filtered correctly above, so we can use selectedProjectName
        // But we need to ensure we're using the correct project name from the filtered projects
        const projectNameToUse = selectedProjectName || (matchedProjects[0]?.ProjectName);
        
        if (projectNameToUse) {
            const match = matchedQuotations[projectNameToUse];
            if (match) {
                setFilteredQuotation({ [projectNameToUse]: match });
            } else {
                setFilteredQuotation(null); // or {} if you prefer
            }
        } else {
            setFilteredQuotation(null);
        }
    }, [selectedProjectName, matchedQuotations, createdProject, matchedProjects]);

    const AllServiceTableRef = useRef(null);
    const AssociatedRef = useRef(null);
    const [HardwarePersons, setHardwarePersons] = useState([]);
    const [installtionPersons, setinstallationPersons] = useState([]);
    const [SoftwarePersons, setSoftwarePersons] = useState([]);
    const [CloudPersons, setCloudPersons] = useState([]);

    const getNetRevenueClass = (value) => {
        if (value < 0) return "text-red-600";
        if (value >= 0 && value < 10) return "text-orange-500";
        return "text-black";
    };

    const getNetRevenueInDollarClass = (value) => {
        if (value < 0) return "text-red-600";
        return "text-black";
    };

    const handlerefresh = useCallback(() => {
        dispatch(fetchSalesTaxes());
        dispatch(fetchDescriptionTasks());
        dispatch(fetchAllProjects());
        dispatch(fetchEmployees());
        dispatch(fetchWorkEntries());
        dispatch(fetchHardwareDescriptions());
        dispatch(fetchQuotations());
        dispatch(fetchSalesHourlyRates());
        dispatch(fetchLeads());
    }, [dispatch]);

    /** After wizard margin save: refresh backend data without resetting Expected Margin UI. */
    const onWizardMarginsSaved = useCallback(() => {
        dispatch(fetchAllProjects());
        dispatch(fetchLeads());
        dispatch(fetchDescriptionTasks());
    }, [dispatch]);

    const clickedLeadId = clickedProject?._id ?? clickedProject?.id;

    const getUpdatedLeadProject = useCallback(
        (proj) => {
            if (!proj) return null;
            const leadId = proj._id ?? proj.id;
            return {
                ...proj,
                QuotedValue:
                    quotedValueState[leadId] !== undefined
                        ? Number(quotedValueState[leadId])
                        : proj.QuotedValue,
            };
        },
        [quotedValueState]
    );

    const serviceTableProject = React.useMemo(
        () => getUpdatedLeadProject(clickedProject ?? createdProject?.[0]),
        [clickedProject, createdProject, getUpdatedLeadProject]
    );

    // Keep expanded lead in sync after margin/quoted saves so Itemized P&L does not revert.
    useEffect(() => {
        if (!clickedLeadId || !createdProject?.length) return;
        const updated = createdProject.find(
            (p) => (p._id ?? p.id) === clickedLeadId
        );
        if (updated) {
            setClickedProject((prev) =>
                prev && (prev._id ?? prev.id) === clickedLeadId ? { ...prev, ...updated } : prev
            );
        }
    }, [createdProject, clickedLeadId]);

    return (
        <div className='pb-6'>
            <div className="w-[99%] min-h-[10vh] max-h-[80vh] overflow-auto pt-6 pb-4">
                <div className="w-full head sticky top-0 z-10 flex text-black bg-[#E8E8E8]">
                    <div className="flex-shrink-0 w-10 px-3 py-2 flex items-center justify-center text-center border text-xs font-bold  tracking-wider bg-[#E8E8E8]">
                        Sr. No
                    </div>
                    <div className="flex-shrink-0 w-40 px-3 py-2 flex gap-2  justify-center align-middle items-center text-center border text-xs font-bold  tracking-wider capitalize bg-[#E8E8E8]">
                        Group Name
                    </div>
                    <div className="flex-shrink-0 w-40 px-3 py-2 flex gap-2  justify-center align-middle items-center text-center border text-xs font-bold  tracking-wider capitalize bg-[#E8E8E8]">
                        Client Name
                    </div>
                    <div className="flex-shrink-0 w-40 px-3 py-2 flex gap-2  justify-center align-middle items-center text-center border text-xs font-bold  tracking-wider capitalize bg-[#E8E8E8]">
                        Project Name

                    </div>
                    <div className="flex-shrink-0 w-40 px-3 py-2 gap-2 flex justify-center align-middle items-center text-center border text-xs font-bold  tracking-wider capitalize bg-[#E8E8E8]">
                        Quoted Price ({currency})
                    </div>
                    <div className="flex-shrink-0 w-40 px-3 py-2 flex justify-center align-middle items-center text-center border text-xs font-bold  tracking-wider capitalize bg-[#E8E8E8]">
                        {`Quoted Expenses (${currency})`}
                    </div>
                    <div className="flex-shrink-0 w-40 px-3 py-2 flex justify-center align-middle items-center text-center border text-xs font-bold tracking-wider capitalize bg-[#E8E8E8]">
                        Gross Profit ({currency})
                    </div>
                    <div className="flex-shrink-0 w-40 px-3 py-2 flex justify-center align-middle items-center text-center border text-xs font-bold  tracking-wider capitalize bg-[#E8E8E8]">
                        G&A Expenses ({currency})
                    </div>
                    <div className="flex-shrink-0 w-24 px-3 py-2 flex justify-center align-middle items-center text-center border text-xs font-bold  tracking-wider capitalize bg-[#E8E8E8]">
                        Tax ({currency})
                    </div>
                    <div className="flex-shrink-0 w-44 flex flex-col justify-center align-middle items-center text-center border text-xs font-bold  tracking-wider capitalize bg-[#E8E8E8]">
                        <div className="h-[50%] w-full flex justify-center align-middle items-center"> Net Revenue</div>
                        <div className="h-[50%] flex w-full">
                            <div className="w-[50%] border flex justify-center align-middle items-center">({currency})</div>
                            <div className="w-[50%] border flex justify-center align-middle items-center">(%)</div>
                        </div>
                    </div>
                    <div className="flex-shrink-0 w-28 px-3 py-2 flex justify-center align-middle items-center text-center border text-xs font-bold  tracking-wider capitalize bg-[#E8E8E8]">
                        Notes
                    </div>
                    <div className="flex-shrink-0 border w-24 px-3 py-3 flex justify-center align-middle items-center text-center  text-xs font-bold  tracking-wider capitalize bg-[#E8E8E8]">
                        Quotation

                    </div>
                </div>
                <>
                    {createdProject?.map((proj, index) => {
                        const matchedRow = calculatedFinanceProjects?.find((row) => row?.projectId === (proj?._id ?? proj?.id))
                        console.log("calculatedFinanceProjects matchedRow", matchedRow)
                        return (
                            <div
                                key={index}
                                className="w-full flex text-black bg-white min-h-[8vh]">
                                <div className="flex-shrink-0 w-10 px-3 py-2 flex items-center justify-center text-center border-b text-xs  tracking-wider ">
                                    {index + 1}
                                </div>
                                <div className="flex-shrink-0 w-40 px-3 py-2 flex gap-2 break-words whitespace-normal justify-center align-middle items-center text-center border-b text-xs  tracking-wider capitalize ">
                                    {getDisplayGroupName(proj)}
                                </div>
                                <div className="flex-shrink-0 w-40 px-3 py-2 flex gap-2 break-words whitespace-normal justify-center align-middle items-center text-center border-b text-xs   tracking-wider capitalize ">
                                    {proj?.ClientName}
                                </div>
                                <div className="flex-shrink-0 w-40 px-3 py-2 flex gap-2 break-words whitespace-normal  justify-center align-middle items-center text-center border-b text-xs  tracking-wider capitalize ">
                                    {proj?.ProjectName}
                                </div>
                                <div className="bg-white  flex-shrink-0 w-40 px-3 py-2 break-all whitespace-normal gap-2 flex justify-center align-middle items-center text-center border-b text-xs  tracking-wider capitalize ">
                                    <input
                                        type="text"
                                        value={
                                            quotedValueState[proj._id] !== undefined
                                                ? USAComma(quotedValueState[proj._id])
                                                : USAComma(proj.QuotedValue)
                                        }
                                        className="p-1 text-center h-full w-full outline-none rounded-md border-b bg-[#cfecf7] border-black break-all whitespace-normal"
                                        onChange={(e) =>
                                            handleQuotedValue(
                                                proj._id,
                                                e.target.value.replace(/,/g, "").replace(/\D/g, "")
                                            )
                                        }
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                SubmitQuotedValueState(proj, quotedValueState[proj._id]);
                                            }
                                        }}
                                    />
                                </div>
                                <div
                                    onClick={() => {
                                        setClickedProject(clickedProject === proj ? null : proj)
                                    }}
                                    className="cursor-pointer bg-white break-all whitespace-normal flex-shrink-0 w-40 px-3 py-2 flex justify-center align-middle items-center text-center border-b text-xs  tracking-wider capitalize">
                                    {USAComma(getQuotedExpenseForProj(proj))}
                                </div>

                                <div className={`${getNetRevenueInDollarClass(matchedRow?.grossProfit)} bg-white flex-shrink-0 break-all whitespace-normal w-40 px-3 py-2 flex justify-center align-middle items-center text-center border-b text-xs  tracking-wider capitalize `}>
                                    {USAComma(matchedRow?.grossProfit)}
                                </div>
                                <div className={`${getNetRevenueInDollarClass(matchedRow?.GAExpenses)} bg-white  flex-shrink-0 break-all whitespace-normal w-40 px-3 py-2 flex justify-center align-middle items-center text-center border-b text-xs tracking-wider capitalize `}>
                                    {USAComma(matchedRow?.GAExpenses)}
                                </div>
                                <div className={`${getNetRevenueInDollarClass(matchedRow?.TaxCalculated)} bg-white  flex-shrink-0 break-all whitespace-normal w-24 px-3 py-2 flex justify-center align-middle items-center text-center border-b text-xs tracking-wider capitalize `}>
                                    {USAComma(matchedRow?.TaxCalculated, { decimals: true })}
                                </div>
                                <div className="bg-white  flex-shrink-0 break-all whitespace-normal w-44 flex flex-col justify-center align-middle items-center text-center border-b text-xs tracking-wider capitalize ">
                                    <div className="flex w-full">
                                        <div className={`${getNetRevenueInDollarClass(matchedRow?.netRevenueInDollar)} w-[50%] flex break-all whitespace-normal justify-center align-middle items-center`}>
                                            {USAComma(matchedRow?.netRevenueInDollar, { decimals: true })}
                                        </div>
                                        <div className={`${getNetRevenueClass(matchedRow?.netRevenueInPercentage)}  w-[50%] flex justify-center  align-middle items-center break-all whitespace-normal`}>
                                            {matchedRow?.netRevenueInPercentage !== undefined && matchedRow?.netRevenueInPercentage !== null 
                                                ? parseFloat(matchedRow.netRevenueInPercentage).toFixed(2) 
                                                : ""}
                                        </div>
                                    </div>
                                </div>
                                <div className="bg-white max-h-16 overflow-auto flex-shrink-0 w-28 px-3 py-2 break-words whitespace-normal flex justify-center align-middle items-center text-center border-b text-xs  tracking-wider capitalize ">
                                    {proj?.comments}
                                </div>
                                <div
                                    onClick={() => {
                                        const status = proj?.Status?.toLowerCase()?.trim();
                                        const isWon = status === "won" || status === "won recurring";
                                        if (subscriptionPackage === "CRM" && isWon) {
                                            return; // Disable click for Won status in CRM package
                                        }
                                        setShowQuoteModal(true);
                                    }}
                                    className={`bg-white  flex-shrink-0 w-24 px-3 py-3 flex justify-center align-middle items-center text-center border-b text-xs tracking-wider capitalize ${
                                        (() => {
                                            const status = proj?.Status?.toLowerCase()?.trim();
                                            const isWon = status === "won" || status === "won recurring";
                                            return subscriptionPackage === "CRM" && isWon;
                                        })()
                                            ? "cursor-not-allowed"
                                            : "cursor-pointer"
                                    }`}>
                                    <TextSnippetIcon className={
                                        (() => {
                                            const status = proj?.Status?.toLowerCase()?.trim();
                                            const isWon = status === "won" || status === "won recurring";
                                            return subscriptionPackage === "CRM" && isWon;
                                        })()
                                            ? "cursor-not-allowed text-gray-400"
                                            : "cursor-pointer"
                                    } />
                                </div>
                            </div>
                        )
                    })}
                </>


            </div>
            <div className={clickedProject ? 'bg-white' : 'hidden'} ref={AllServiceTableRef}>
                {serviceTableProject && filteredQuotation && (
                    <AllServiceTable
                        filteredQuotation={filteredQuotation}
                        selectedProject={serviceTableProject}
                        projects={projects}
                        setinstallationPersons={setinstallationPersons}
                        setSoftwarePersons={setSoftwarePersons}
                        setCloudPersons={setCloudPersons}
                        setHardwarePersons={setHardwarePersons}
                        tasks={tasks}
                        items={items}
                        handlerefresh={handlerefresh}
                        preserveMarginsOnRefresh
                        onWizardMarginsSaved={onWizardMarginsSaved}
                        onTableServiceTotalsChange={setTableServiceTotals}
                        onTotalCostPerServiceTotalChange={handleTotalCostPerServiceTotalChange}
                    />
                )}
            </div>
            <div className='bg-white'>

                {(HardwarePersons.length && clickedProject) ? (
                    <HardwareTypeServiceTable
                        items={items}
                        AssociatedRef={AssociatedRef}
                        currentPerson={HardwarePersons}
                        filteredQuotation={filteredQuotation}
                        matchedProjects={matchedProjects}
                        tasks={tasks}
                        selectedProject={clickedProject}
                    />
                ) : (
                    <> </>
                )}
            </div>
            {/* For Installation */}
            <div className='bg-white'>
                {(installtionPersons.length && clickedProject) ? (
                    <SalesFinanceEfforts tasks={tasks}
                        AssociatedRef={AssociatedRef}
                        currentPerson={installtionPersons}
                        filteredQuotation={filteredQuotation}
                        matchedProjects={matchedProjects} />
                ) : (
                    <> </>
                )}
            </div>
            {/* For software */}
            <div className='bg-white'>
                {(SoftwarePersons.length && clickedProject) ? (
                    <SoftwareTypeServiceTable
                        AssociatedRef={AssociatedRef}
                        currentPerson={SoftwarePersons}
                        filteredQuotation={filteredQuotation}
                        matchedProjects={matchedProjects}
                        tasks={tasks} />
                ) : (
                    <> </>
                )}
            </div>
            {/* for  Cloud  */}
            <div className='bg-white'>
                {(CloudPersons.length && clickedProject) ? (
                    <SoftwareTypeServiceTable
                        AssociatedRef={AssociatedRef}
                        currentPerson={CloudPersons}
                        filteredQuotation={filteredQuotation}
                        matchedProjects={matchedProjects}
                        tasks={tasks} />
                ) : (
                    <> </>
                )}
            </div>

            <div className='w-[99%] flex justify-end pt-2'>
                <div className="flex gap-4">
                    <button
                        onClick={() => {
                            // In ERP module, when in P&L table, always go back to Response Received (step 3)
                            // This handles all cases: whether all managers accepted or only some
                            if (subscriptionPackage === "ERP") {
                                // Always go back to Response Received in ERP module
                                dispatch(setOperationProjectStatus("response received"));
                                dispatch(setCreatedProject(createdProject));
                                dispatch(goToStep(3)); // Go to step 3 where ResponseReceivedWizard is shown
                            } else {
                                // For CRM module, use normal goBack
                                dispatch(goBack());
                            }
                        }}
                        className=" py-2 px-7 bg-black overflow-hidden shadow-md text-white rounded-lg"
                    >
                        Back
                    </button>
                    <button
                        onClick={() => {
                            handleNext()
                        }}
                        className=" py-2 px-7 bg-[#e32278] overflow-hidden shadow-md text-white rounded-lg"
                    >
                        Next
                    </button>
                </div>
            </div>
            {showQuoteModal && (
                <QuotationWizard
                    tasks={tasks}
                    items={items}
                    filteredQuotation={filteredQuotation}
                    setShowQuoteModal={setShowQuoteModal}
                    selectedProject={createdProject[0]?.ProjectName}
                    selectedGroup={getDisplayGroupName(createdProject?.[0] || {})}
                    tableServiceTotals={tableServiceTotals}
                />
            )}
        </div>
    )
}

export default PandLWizardAdvancedPlan
